module.exports = __webpack_public_path__ + "assets/img/332c-pg.svg";